export const gptResults = {
    comedy: ['3 Idiots', 'Hera Pheri', 'Andaz Apna Apna', 'Chupke Chupke', 'Golmaal'],
    horror: ['The Conjuring', 'Hereditary', 'A Nightmare on Elm Street', 'The Exorcist', 'Insidious'],
    romantic: ['Dilwale Dulhania Le Jayenge', 'Kabhi Khushi Kabhie Gham', 'Jab We Met', 'Veer-Zaara', 'Kal Ho Naa Ho'],
    action: ['Mad Max: Fury Road', 'Die Hard', 'John Wick', 'The Dark Knight', 'Gladiator'],
    zombie: ['28 Days Later', 'Dawn of the Dead', 'Train to Busan', 'The Sadness', 'Resident Evil'],
    horror_comedy: ['Bhool Bhulaiyaa', 'Stree', 'Go Goa Gone', 'Bhoothnath', 'Roohi'],
    psychothriller: ['Se7en', 'Psycho', 'Fight Club', 'Black Swan', 'Gone Girl']
}